// extracted by mini-css-extract-plugin
export default {"tableHeader":"B4YNOAJbb4k_qyRLPkt4"};